import Client from '@/hosted_fields/common/connection/client';
import actionHolder from '@/hosted_fields/common/holder';
import {ActionInnerMessage} from '@/hosted_fields/common/types';
import Master from '@/hosted_fields/master/main';
import {Master as M} from '@/hosted_fields/common/enums';
import {safeGet} from '@/utils/utility-functions';

export default (client: Client) => {
  actionHolder.registerAction(M.Actions.RegisterMaster, {
    handle(message: ActionInnerMessage) {
      let reply = {
        registered: true,
      };

      Master.createOne(client, message.data);
      return new Promise((resolve) => resolve(reply));
    },
  });

  actionHolder.registerAction(M.Actions.SetBusinessEntity, {
    handle(message: ActionInnerMessage) {
      return Master.instance().setBusinessEntityAction(message);
    },
  });

  actionHolder.registerAction(M.Actions.RegisterComponent, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.registerComponent(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GetTranslations, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getCheckoutUtilsPlugin()
        .then((plugin) => plugin.getTranslations(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.RegisterField, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.registerField(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.TokenizeCardData, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.tokenizeCardData(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.TokenizeBankData, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.tokenizeBankData(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.RelayEvent, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.relayEvent(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.Update, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.update(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.Broadcast, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.broadcast(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.Focus, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.focus(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.Blur, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.blur(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.Clear, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.clear(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.Destroy, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.destroy(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.Validate, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.validate(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.WhitelistFonts, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.whitelistFonts(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.UpdateStyles, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.updateStyles(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.UpdatePlaceholder, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.updatePlaceholder(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.UpdateAriaLabel, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.updateAriaLabel(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.UpdateIcon, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.updateIcon(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.UpdateLocale, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.updateLocale(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.IDealFocus, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.iDealFocus(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.IDealBlur, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.iDealBlur(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.UpdateIDealBankList, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.updateIDealBankList(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.IDealBankSelected, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.iDealBankSelected(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.CaptureException, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getLoggerPlugin()
        .then((plugin) => {
          if (!message) {
            const data = {
              js_error_code: 'action-missing-payload',
              js_window_type: 'master',
              js_action: M.Actions.CaptureException,
            };
            return plugin.captureKVL(data);
          } else {
            return plugin.captureException(message.data);
          }
        });
    },
  });

  actionHolder.registerAction(M.Actions.CaptureKVL, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getLoggerPlugin()
        .then((plugin) => plugin.captureKVL(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollAdyenBancontact, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getBancontactPlugin()
        .then((plugin) => plugin.pollAdyenBancontactVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.StopAdyenBancontactPoll, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getBancontactPlugin()
        .then((plugin) => plugin.stopAdyenBancontactPoll(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetAdyenBancontactVerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollAdyenIDeal, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getIdealPlugin()
        .then((plugin) => plugin.pollAdyenIDealVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.StopAdyenIDealPoll, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getIdealPlugin()
        .then((plugin) => plugin.stopAdyenIDealPoll(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetAdyenIDealVerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollStripeIDeal, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getIdealPlugin()
        .then((plugin) => plugin.pollStripeIDealVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.StopStripeIDealPoll, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getIdealPlugin()
        .then((plugin) => plugin.stopStripeIDealPoll(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetStripeIDealVerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollAdyenSofort, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getSofortPlugin()
        .then((plugin) => plugin.pollAdyenSofortVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.StopAdyenSofortPoll, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getSofortPlugin()
        .then((plugin) => plugin.stopAdyenSofortPoll(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetAdyenSofortVerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollAdyenGiropay, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getGiropayPlugin()
        .then((plugin) => plugin.pollAdyenGiropayVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.StopAdyenGiropayPoll, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getGiropayPlugin()
        .then((plugin) => plugin.stopAdyenGiropayPoll(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetAdyenGiropayVerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollAdyenDotpay, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getDotpayPlugin()
        .then((plugin) => plugin.pollAdyenDotpayVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.StopAdyenDotpayPoll, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getDotpayPlugin()
        .then((plugin) => plugin.stopAdyenDotpayPoll(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetAdyenDotpayVerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GetDotpayGatewayDetails, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getDotpayPlugin()
        .then((plugin) => plugin.getDotpayGatewayDetails(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GetIDealGatewayDetails, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getIdealPlugin()
        .then((plugin) => plugin.getIDealGatewayDetails(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GetFasterPaymentsGatewayDetails, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getFasterPaymentsPlugin()
        .then((plugin) => plugin.getFasterPaymentsGatewayDetails(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GetPayToGatewayDetails, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getPayToPlugin()
        .then((plugin) => plugin.getPayToGatewayDetails(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GetSepaInstantTransferGatewayDetails, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getSepaInstantTransferPlugin()
        .then((plugin) => plugin.getSepaInstantTransferGatewayDetails(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.ConfirmPaymentIntent, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.confirmPaymentIntent(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.CancelPaymentIntent, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.cancelPaymentIntent(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.RetrievePaymentIntent, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.retrievePaymentIntent(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetPaymentIntent3DSResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollPaymentIntent3DSResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.pollPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollPaymentIntentResultBeforeRequiresChallenge, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.pollPaymentIntentResultBeforeRequiresChallenge(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.StopPollPaymentIntent3DSResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.stopPollPaymentIntent3DSResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.FetchGatewayToken, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.fetchGatewayToken(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.FetchGatewayCredential, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.fetchGatewayCredential(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetupWorker, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setupPaymentIntentWorker(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GenerateBraintreeClientToken, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.generateBraintreeClientToken(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.RetrieveBraintreePaymentMethodNonce, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.retrieveBraintreePaymentMethodNonce(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.CreateBluesnapPfToken, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.createBluesnapPfToken(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GenerateDeviceDataJWT, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.generateDeviceDataJWT(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GenerateAdyenOriginKey, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.generateAdyenOriginKey(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollAdyen3DS1, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.pollAdyen3DS1VerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollCheckoutCom3DS, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.pollCheckoutCom3DSVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PollCybersource3DS, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.pollCybersource3DSVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetAdyen3DS1VerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setAdyen3DS1VerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetCheckoutCom3DSVerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setCheckoutCom3DSVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetCybersource3DSVerificationResult, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getThreeDSPlugin()
        .then((plugin) => plugin.setCybersource3DSVerificationResult(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.PortalLogout, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getCheckoutUtilsPlugin()
        .then((plugin) => plugin.portalLogout());
    },
  });

  actionHolder.registerAction(M.Actions.LoadJsInfo, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getCheckoutUtilsPlugin()
        .then((plugin) => plugin.getInfo());
    },
  });

  actionHolder.registerAction(M.Actions.GetBinData, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getCheckoutUtilsPlugin()
        .then((plugin) => plugin.getBinData(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.SetHpData, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getCheckoutUtilsPlugin()
        .then((plugin) => plugin.setHpData(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.GetHpData, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getCheckoutUtilsPlugin()
        .then((plugin) => plugin.getHpData(safeGet(message, 'data.param')));
    },
  });

  actionHolder.registerAction(M.Actions.CreateSubscriptionEstimate, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getFunctionsPlugin()
        .then((plugin) => plugin.createSubscriptionEstimate(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.UpdateSubscriptionEstimate, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getFunctionsPlugin()
        .then((plugin) => plugin.updateSubscriptionEstimate(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.RenewSubscriptionEstimate, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getFunctionsPlugin()
        .then((plugin) => plugin.renewSubscriptionEstimate(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.ValidateVat, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getFunctionsPlugin()
        .then((plugin) => plugin.validateVat(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.FetchPlaidLinkToken, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getDirectDebitPlugin()
        .then((plugin) => plugin.fetchPlaidLinkToken(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.FetchGWPaymentMethodConfig, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getDirectDebitPlugin()
        .then((plugin) => plugin.fetchGWPaymentMethodConfig(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.ValidateApplePaySession, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getApplePayPlugin()
        .then((plugin) => plugin.validateApplePaySession(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.selectTestCard, {
    handle(message: ActionInnerMessage) {
      return Master.instance()
        .getComponentsAndFieldsPlugin()
        .then((plugin) => plugin.selectTestCard(message.data));
    },
  });

  actionHolder.registerAction(M.Actions.InitializeCaptcha, {
    handle(message: ActionInnerMessage) {
      return Master.instance().initializeCaptcha(message.data);
    },
  });

  actionHolder.registerAction(M.Actions.GenerateCaptchaToken, {
    handle(message: ActionInnerMessage) {
      return Master.instance().generateCaptchaToken(message.data);
    },
  });

  actionHolder.registerAction(M.Actions.FetchAmazonPayButtonSignature, {
    handle: (message: ActionInnerMessage) => {
      return Master.instance()
        .getAmazonPayPlugin()
        .then((plugin) => plugin.generateAmazonPayButtonSignature(message.data));
    },
  });
};
